/**
 * Route pattern for the Join page. `joinTripPath` in `./core` builds concrete
 * paths for it; the core test pins the two to the same `/join/` prefix. (Own
 * module so the page file only exports a component — react-refresh.)
 */
export const JOIN_TRIP_PATH = '/join/:tripCode'
